export default __webpack_public_path__ + "static/media/diceden.51509c0b.png";